import { Link, TextStyle } from '@superops/ui-design-system';
import React from 'react';
import { Tooltip } from 'react-clone-tippy';
import { SVGIcon } from '@superops/super-icons';
import { getTranslatedText, useUserMSPCheckHook } from '@nile/components';
import { injectIntl } from 'react-intl';
import { useFlags } from 'launchdarkly-react-client-sdk';

/**
 * Cells are specific to the components using the table.
 * This link cell is used to perform an action/redirection when clicked on it.
 */

function LinkCell(props) {
  const { intl, cell } = props;
  const meta = cell?.row?.original;
  const flags = useFlags();
  const isSideConversationAvailable = useUserMSPCheckHook();
  const { actions } = cell.column;
  return cell.value ? (
    <div className="ellipsis position-relative mw-100 flex actr fx-sb">
      <Link removeUnderline onClick={actions.onClick.bind(this, meta)}>
        {cell.value}
      </Link>
      {isSideConversationAvailable && !!meta?.numberOfUnreadVendorConversation && (
        <Tooltip
          html={
            <div>
              {getTranslatedText(intl, 'vendor.replied.ticket.onhover.tooltip')}
            </div>
          }
          delay={400}
          duration={250}
          position="bottom"
          inertia
          trigger="mouseenter"
          animation="shift"
          animateFill={false}
        >
          <div className="fx actr ml-10">
            <SVGIcon name="Helpcenter" color="red" size="sm" />
          </div>
        </Tooltip>
      )}
    </div>
  ) : (
    <TextStyle variation="subdued">NA</TextStyle>
  );
}

export default injectIntl(LinkCell);
